// @flow
import React, { PureComponent } from "react";
import { Helmet } from "react-helmet";
import Lightbox from "./Lightbox";
import env from "../etc/env";
import config from "../etc/variables";
import { type Props } from "./";
import "./App.css";

// Destructuring here to help indicate which vars are used by this component
const {
  appTitle,
  appDescription,
  appLogo,
  appLogoWidth,
  appLogoHeight,
  colorTheme,
} = config;
const { ROOT_URL } = env;

type State = {};

// PureComponent can be optimized better than stateless!
// Ref: https://tribou.page.link/pure
export default class App extends PureComponent<Props, State> {
  render() {
    return (
      <div className="App">
        <Helmet>
          <meta name="description" content={appDescription} />
          <meta name="theme-color" content={colorTheme} />
          <meta
            name="msapplication-TileImage"
            content={`${ROOT_URL}${appLogo}`}
          />
          <meta property="og:title" content={appTitle} />
          <meta property="og:image" content={`${ROOT_URL}${appLogo}`} />
          <meta property="og:image:width" content={appLogoWidth} />
          <meta property="og:image:height" content={appLogoHeight} />
          <meta property="og:url" content={ROOT_URL} />
          <meta property="og:description" content={appDescription} />
          <title>{appTitle}</title>
          <link
            rel="stylesheet"
            type="text/css"
            href="https://fonts.googleapis.com/css?family=Source+Code+Pro:300"
          />
        </Helmet>
        <Lightbox />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js